export default __webpack_public_path__ + "static/media/ISO 37001 2025_IT345302   - FINCANTIERI SI S.P.A ita.2839a9b8.pdf";